import { render, staticRenderFns } from "./VEmail.vue?vue&type=template&id=51c1b240&"
import script from "./VEmail.vue?vue&type=script&lang=js&"
export * from "./VEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports